/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import { Component, Fragment } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';

import { Required } from '@motili/ui';
import styles from './FormLayout.module.scss';
import legacyStyles from './FormLayout-legacy.module.scss';
import { useUI } from '../../context/UIContext';

export class FormContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        noBackground: PropTypes.bool,
        style: PropTypes.object,
        editing: PropTypes.bool,
        controlId: PropTypes.string,
        className: PropTypes.string,
    };

    static defaultProps = {
        noBackground: false,
        style: {},
        editing: false,
    };

    render() {
        return (
            <div
                className={`${styles['form-container']} ${
                    this.props.noBackground ? styles['no-background'] : ''
                } ${this.props.editing ? styles.editing : ''} ${
                    this.props.className || ''
                }`}
                style={this.props.style}
                id={this.props.controlId}
            >
                {this.props.children}
            </div>
        );
    }
}

export class FormSelectableContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        noBackground: PropTypes.bool,
        style: PropTypes.object,
        handleOnClick: PropTypes.func,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };

    static defaultProps = {
        noBackground: false,
        style: {},
    };

    render() {
        return (
            <div
                className={`${styles['form-container']} ${
                    this.props.noBackground ? styles['no-background'] : ''
                }`}
                style={{ cursor: 'pointer', ...this.props.style }}
                onClick={e => this.props.handleOnClick(this.props.id, e)}
            >
                {this.props.children}
            </div>
        );
    }
}

export class FormSectionHeader extends Component {
    static propTypes = {
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
            .isRequired,
        imgSrc: PropTypes.node,
        actionItems: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    handleSelect: PropTypes.func.isRequired,
                    style: PropTypes.object,
                })
            ),
        ]),
        buttonGroup: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
        requiredFields: PropTypes.bool,
        icon: PropTypes.node,
        toolbar: PropTypes.element,
    };

    static defaultProps = {};

    render() {
        if (this.props.toolbar) {
            return (
                <div
                    className={
                        this.props.requiredFields
                            ? styles['form-section-header-with-required']
                            : styles['form-section-header']
                    }
                >
                    <div className={styles.formSectionToolbar}>
                        <div className={styles.right}>
                            <h3 className={styles.header}>
                                {this.props.title}
                            </h3>
                            <div className={styles.underline} />
                        </div>
                        <div className={styles.left}>{this.props.toolbar}</div>
                    </div>
                </div>
            );
        }
        if (this.props.icon && this.props.imgSrc) {
            console.warn(
                'Too many props passed to FormSectionHeader. This component only allows either icon or imgSrc, not both.'
            );
            return (
                <div
                    className={
                        this.props.requiredFields
                            ? styles['form-section-header-with-required']
                            : styles['form-section-header']
                    }
                >
                    <div className={styles.right}>
                        <h3 className={styles.header}>{this.props.title}</h3>
                        <div className={styles.underline} />
                    </div>
                    {this.props.actionItems &&
                        this.props.actionItems.map((actionItem, idx) => (
                            <Fragment key={idx}>
                                {idx > 0 && <span>&nbsp;|&nbsp;</span>}
                                <div
                                    onClick={actionItem.handleSelect}
                                    style={{
                                        ...(actionItem.style || {}),
                                        cursor: 'pointer',
                                    }}
                                >
                                    {actionItem.name}
                                </div>
                            </Fragment>
                        ))}
                    {this.props.buttonGroup}
                </div>
            );
        }
        if (!this.props.imgSrc && !this.props.icon) {
            return (
                <div
                    className={
                        this.props.requiredFields
                            ? styles['form-section-header-with-required']
                            : styles['form-section-header']
                    }
                >
                    <div className={styles.right}>
                        <h3 className={styles.header}>{this.props.title}</h3>
                        <div className={styles.underline} />
                    </div>
                    {this.props.actionItems &&
                        this.props.actionItems.map((actionItem, idx) => (
                            <Fragment key={idx}>
                                {idx > 0 && <span>&nbsp;|&nbsp;</span>}
                                <div
                                    onClick={actionItem.handleSelect}
                                    style={{
                                        ...(actionItem.style || {}),
                                        cursor: 'pointer',
                                    }}
                                >
                                    {actionItem.name}
                                </div>
                            </Fragment>
                        ))}
                    {this.props.buttonGroup}
                </div>
            );
        }
        if (this.props.imgSrc) {
            return (
                <div
                    className={
                        this.props.requiredFields
                            ? styles['form-section-header-with-required']
                            : styles['form-section-header']
                    }
                >
                    {this.props.imgSrc && (
                        <div className={styles.left}>
                            <img
                                className={styles.image}
                                src={this.props.imgSrc}
                                alt=''
                            />
                        </div>
                    )}
                    <div className={styles.right}>
                        <h3 className={styles.header}>{this.props.title}</h3>
                        <div className={styles.underline} />
                    </div>
                    {this.props.actionItems &&
                        this.props.actionItems.map((actionItem, idx) => (
                            <Fragment key={idx}>
                                {idx > 0 && <span>&nbsp;|&nbsp;</span>}
                                <div
                                    onClick={actionItem.handleSelect}
                                    style={{
                                        ...(actionItem.style || {}),
                                        cursor: 'pointer',
                                    }}
                                >
                                    {actionItem.name}
                                </div>
                            </Fragment>
                        ))}
                    {this.props.buttonGroup}
                </div>
            );
        }
        if (this.props.icon) {
            return (
                <div
                    className={
                        this.props.requiredFields
                            ? styles['form-section-header-with-required']
                            : styles['form-section-header']
                    }
                >
                    {this.props.icon && (
                        <div className={styles.left}>{this.props.icon}</div>
                    )}
                    <div className={styles.right}>
                        <h3 className={styles.header}>{this.props.title}</h3>
                        <div className={styles.underline} />
                    </div>
                    {this.props.actionItems &&
                        this.props.actionItems.map((actionItem, idx) => (
                            <Fragment key={idx}>
                                {idx > 0 && <span>&nbsp;|&nbsp;</span>}
                                <div
                                    onClick={actionItem.handleSelect}
                                    style={{
                                        ...(actionItem.style || {}),
                                        cursor: 'pointer',
                                    }}
                                >
                                    {actionItem.name}
                                </div>
                            </Fragment>
                        ))}
                    {this.props.buttonGroup}
                </div>
            );
        }
    }
}

export class FormSectionHeaderWithSubTitle extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        subTitle: PropTypes.node,
        actionItems: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                handleSelect: PropTypes.func.isRequired,
                style: PropTypes.object,
            })
        ),
        buttonGroup: PropTypes.element,
    };

    render() {
        return (
            <div className={styles['form-section-header']}>
                <div className={styles['form-section-header-with-subtitle']}>
                    <div className={styles.title}>{this.props.title}</div>
                    <div className={styles.subtitle}>{this.props.subTitle}</div>
                    <div className={styles.underline} />
                </div>
                {this.props.actionItems &&
                    this.props.actionItems.map((actionItem, idx) => (
                        <Fragment key={idx}>
                            {idx > 0 && <span>&nbsp;|&nbsp;</span>}
                            <div
                                onClick={actionItem.handleSelect}
                                style={{
                                    ...(actionItem.style || {}),
                                    cursor: 'pointer',
                                }}
                            >
                                {actionItem.name}
                            </div>
                        </Fragment>
                    ))}
                {this.props.buttonGroup}
            </div>
        );
    }
}

export class FormSectionHeaderRequiredFieldsInline extends Component {
    static propTypes = {
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
            .isRequired,
        requiredFields: PropTypes.bool,
        buttonGroup: PropTypes.element,
    };

    static defaultProps = {};

    render() {
        return (
            <div className={styles['form-section-header']}>
                <div
                    className={styles.right}
                    style={{ flexDirection: 'row', justifyContent: 'start' }}
                >
                    <h3 className={styles.header}>{this.props.title}</h3>
                </div>
                {this.props.buttonGroup}
            </div>
        );
    }
}

export class FormRowComponent extends Component {
    static propTypes = {
        children: PropTypes.node,
        reverse: PropTypes.bool,
        style: PropTypes.object,
        className: PropTypes.string,
        uiStyles: PropTypes.object,
    };

    static defaultProps = {};

    render() {
        return (
            <div
                className={`${
                    this.props.reverse
                        ? this.props.uiStyles['form-row-reverse']
                        : this.props.uiStyles['form-row']
                } ${this.props.className || ''}`}
                style={this.props.style}
            >
                {this.props.children}
            </div>
        );
    }
}
export const FormRow = props => {
    const { isLegacyUI } = useUI();
    const uiStyles = isLegacyUI ? legacyStyles : styles;
    return <FormRowComponent {...props} uiStyles={uiStyles} />;
};

export class FormElement extends Component {
    static propTypes = {
        children: PropTypes.node,
        flex2: PropTypes.bool,
        flex3: PropTypes.bool,
        verticalCenter: PropTypes.bool,
        style: PropTypes.object,
        className: PropTypes.string,
    };

    static defaultProps = {
        flex2: false,
        flex3: false,
        verticalCenter: false,
    };

    render() {
        let className = `${styles['form-element']}${
            this.props.flex2 ? ` ${styles['flex-2']}` : ''
        }${this.props.flex3 ? ` ${styles['flex-3']}` : ''}${
            this.props.verticalCenter ? ` ${styles['vertical-center']}` : ''
        }`;
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        return (
            <div className={className} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

export class FormElementSeparator extends Component {
    static propTypes = {};

    static defaultProps = {};

    render() {
        return (
            <div className={styles['form-element-separator']}>
                <div />
            </div>
        );
    }
}

export function OneOptionRequiredText() {
    return (
        <div className={styles.requiredText}>
            AT LEAST ONE REQUIRED <Required label='(Required)' space={false} />
        </div>
    );
}
